import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import TopMenu from './components/TopMenu';
import Home from './components/Home';
import ProfDashboard from './components/ProfDashboard';
import AdminDashboard from './components/AdminDashboard';
import ClassesTable from './components/ClassesTable';
import Login from './components/Login';
import Register from './components/Register';
import ActivitesTable from "./components/ActivitesTable";
import SuiviElevesDashboard from "./components/SuiviElevesDashboard";
import CompetencesTable from "./components/CompetencesTable";
import ElevesParClasse from './components/ElevesParClasse';
import EleveSuiviDashboard from './components/EleveSuiviDashboard';

import AppsMenu from './components/AppsMenu';
import JugeBoxeApp from './components/jugeboxe/JugeBoxeApp';
import JugeBoxeQrManager from './components/jugeboxe/JugeBoxeQrManager';
import JugeBoxeQrPrint from './components/jugeboxe/JugeBoxeQrPrint';
import StatsClasse from './components/jugeboxe/StatsClasse';
import ResultatSoloBoxe from './components/jugeboxe/ResultatSoloBoxe';
import StatsElevesPage from './components/jugeboxe/StatsElevesPage';

import CarnetMuscuHome from './components/carnet_muscu/CarnetMuscuHome';
import AddSeance from './components/carnet_muscu/AddSeance';
import ScanSeanceQR from './components/carnet_muscu/ScanSeanceQR';
import MonCarnet from './components/carnet_muscu/MonCarnet';
import MuscuClasses from './components/carnet_muscu/MuscuClasses';
import CarnetMuscuSettingsManager from './components/carnet_muscu/CarnetMuscuSettingsManager';
import CarnetMuscuClassDetail from './components/carnet_muscu/CarnetMuscuClassDetail';
import TeacherMuscuCarnetViewer from './components/carnet_muscu/TeacherMuscuCarnetViewer';

import BadmintonHome from './components/badminton/BadmintonHome';
import MatchSimple from './components/badminton/MatchSimple';
import MatchAManiereMobile from './components/badminton/MatchAManiereMobile';
import DefiBadMatch from './components/badminton/DefiBadMatch';
import DefiBadSettings from './components/badminton/DefiBadSettings';
import Exercices from './components/badminton/Exercices';

import api from "./api";

const LAST_KNOWN_USER_ROLE_KEY = "lastKnownUserRole";
const teacherRoles = ["admin", "prof", "teacher", "enseignant", "formateur"];

function CarnetMuscuSettingsPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  return (
    <div>
      <CarnetMuscuSettingsManager
        open={open}
        onClose={() => {
          setOpen(false);
          navigate('/apps/carnet-muscu');
        }}
      />
    </div>
  );
}

function DefiBadSettingsWrapper() {
  const navigate = useNavigate();
  return (
    <DefiBadSettings
      navigateToMatches={(classeId) => navigate('/apps/badminton/defi/matches', { state: { initialClasse: classeId } })}
    />
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [authLoading, setAuthLoading] = useState(!!localStorage.getItem("token"));
  const lastKnownUserRole = localStorage.getItem(LAST_KNOWN_USER_ROLE_KEY) || "";
  const isTeacherUser = teacherRoles.includes(user?.role);
  const canAccessTeacherJugeBoxe = !!token && (isTeacherUser || (authLoading && teacherRoles.includes(lastKnownUserRole)));

  useEffect(() => {
    if (token) {
      setAuthLoading(true);
      api.get('/users/me')
        .then(res => {
          setUser(res.data);
          if (res.data?.role) {
            localStorage.setItem(LAST_KNOWN_USER_ROLE_KEY, res.data.role);
          }
        })
        .catch(() => {
          setUser(null);
          setToken('');
          localStorage.removeItem("token");
          localStorage.removeItem(LAST_KNOWN_USER_ROLE_KEY);
        })
        .finally(() => setAuthLoading(false));
    } else {
      setUser(null);
      setAuthLoading(false);
      localStorage.removeItem(LAST_KNOWN_USER_ROLE_KEY);
    }
  }, [token]);

  const handleSetToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem("token", newToken);
  };

  const handleLogout = () => {
    setUser(null);
    setToken('');
    localStorage.removeItem("token");
    localStorage.removeItem(LAST_KNOWN_USER_ROLE_KEY);
  };

  return (
    <Router>
      <TopMenu user={user} handleLogout={handleLogout} />

      <Routes>
        <Route path="/apps" element={<AppsMenu user={user} />} />

        <Route path="/apps/juge-boxe/qr-manager" element={canAccessTeacherJugeBoxe ? <JugeBoxeQrManager /> : <Navigate to="/apps/juge-boxe" replace />} />
        <Route path="/apps/juge-boxe/qr-print" element={canAccessTeacherJugeBoxe ? <JugeBoxeQrPrint /> : <Navigate to="/apps/juge-boxe" replace />} />
        <Route path="/apps/juge-boxe/stats" element={<StatsClasse />} />
        <Route path="/apps/juge-boxe/resultat-solo" element={<ResultatSoloBoxe />} />
        <Route path="/apps/juge-boxe/*" element={<JugeBoxeApp user={user} />} />
        <Route path="/jugeboxe/stats-eleves" element={<StatsElevesPage />} />

        <Route path="/apps/carnet-muscu" element={<CarnetMuscuHome />} />
        <Route path="/apps/carnet-muscu/classes" element={<MuscuClasses />} />
        <Route path="/apps/carnet-muscu/classes/:classeId" element={<CarnetMuscuClassDetail />} />
        <Route path="/apps/carnet-muscu/suivi-eleves" element={<TeacherMuscuCarnetViewer />} />
        <Route path="/carnet-muscu/ajouter" element={<AddSeance />} />
        <Route path="/carnet-muscu/mon-carnet" element={<MonCarnet />} />
        <Route path="/carnet-muscu/scan" element={<ScanSeanceQR />} />

        <Route path="/apps/badminton" element={<BadmintonHome />} />
        <Route path="/apps/badminton/match-simple" element={<MatchSimple />} />
        <Route path="/apps/badminton/match-a-la-maniere" element={<MatchAManiereMobile />} />
        <Route path="/apps/badminton/defi/manage" element={<DefiBadSettingsWrapper />} />
        <Route path="/apps/badminton/defi/matches" element={<DefiBadMatch />} />
        <Route path="/apps/badminton/exercices" element={<Exercices />} />

        <Route path="/eleve/:id" element={<EleveSuiviDashboard />} />

        {!token || !user ? (
          <>
            <Route path="/" element={<Home token={token} user={user} handleLogout={handleLogout} />} />
            <Route path="/login" element={<Login setToken={handleSetToken} />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <>
            <Route path="/" element={<ProfDashboard user={user} />} />
            <Route path="/prof" element={<ProfDashboard user={user} />} />
            <Route path="/classes" element={<ClassesTable token={token} />} />
            <Route path="/activites" element={<ActivitesTable />} />
            <Route path="/suivi-eleves" element={<SuiviElevesDashboard />} />
            <Route path="/activites/:activiteId/competences" element={<CompetencesTable />} />
            <Route path="/eleves/classe/:classeId" element={<ElevesParClasse />} />
            <Route path="/apps/carnet-muscu/settings" element={<CarnetMuscuSettingsPage />} />

            {user.role === 'admin' && (
              <>
                <Route path="/admin" element={<AdminDashboard user={user} />} />
                <Route path="/profs" element={<Navigate to="/admin" replace />} />
                <Route path="/addprof" element={<Navigate to="/admin" replace />} />
              </>
            )}

            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}